import React from 'react'
import { Breadcrumb } from 'react-breadcrumbs'
import { Col } from 'react-bootstrap'
import { HideWhenBlocked } from './../../Containers/UIBlock/HideWhenBlocked'
import { LayoutDashboard } from './../../Components/Layout/Dashboard'
import { CampaignsWrapper } from './../../Components/Campaigns/CampaignsWrapper'
import { Breadcrumbs } from './../../Components/Breadcrumbs'
import { PageTitle } from './../../Components/PageTitle'
import { authorization } from './../../Module/Auth/Auth'
import CampaignsIcon from './../../Assets/Images/icons/campaigns'
import DataFetchingComponent from './../../Components/DataFetchingComponent'
import FilterAndPaginationComponent from './../../Components/FilterAndPaginationComponent'
import { CardsList } from './../../Components/CardsList'
import CampaignCard from '../../Components/Campaigns/CampaignCard'
import SubmitButton from 'Components/Form/SubmitButton'

const View = props => {
  var { filters, fetchData, ...otherProps } = props

  return (
    <HideWhenBlocked>
      <LayoutDashboard>
        <CampaignsWrapper>
          <Breadcrumbs icon={<CampaignsIcon style={{ width: 16 }} />} />
          <Breadcrumb data={{ title: 'Campaigns', pathname: 'campaigns' }} />
          <PageTitle>Campaigns</PageTitle>

          {authorization.isAdmin() && (
            <SubmitButton
              value="Create campaign"
              id="create-campaign-button"
              className="create-campaign"
              hideSvg={true}
              onClick={() => props.history.push(`${props.match.url}/create`)}
            />
          )}
          <DataFetchingComponent
            filters={filters}
            fetchData={fetchData}
            showSearch={false}
            Component={props => <ContentView {...props} {...otherProps} />}
          />
        </CampaignsWrapper>
      </LayoutDashboard>
    </HideWhenBlocked>
  )
}

export default View

const ContentView = props => {
  return (
    <FilterAndPaginationComponent
      {...props}
      Component={innerProps => {
        return (
          <div>
            <CardsList>
              {innerProps.data.map(campaign => {
                return (
                  <Col xs={3} key={'' + campaign.id}>
                    <CampaignCard
                      title={campaign.name || ''}
                      subTitle={campaign.client}
                      description={
                        <div>
                          Number of cities{' '}
                          <span className="number">{campaign.totalCities}</span>
                        </div>
                      }
                      footer={campaign.type}
                      img={campaign.clientLogo}
                      viewPath={`${props.match.url}/${campaign.id}/city-plans`}
                      editPath={
                        authorization.isClient()
                          ? ''
                          : `${props.match.url}/${campaign.id}/edit`
                      }
                      onClick={() =>
                        props.history.push(
                          `${props.match.url}/${
                            campaign.id
                          }/dashboard/overview`,
                        )
                      }
                      clickable
                      status={campaign.status}
                      campaignTimeRange={campaign.campaignTimeRange}
                    />
                  </Col>
                )
              })}
            </CardsList>
          </div>
        )
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/View.js